import type { OrderDto } from "@/api/dtos";
import type { Order } from "@/api/order/_models/Order";
import { toExternalReferenceFromOrderExternalReferenceDto } from "./toExternalReferenceFromOrderExternalReferenceDto";
import { toExternalStatusFromOrderExternalStatusDto } from "./toExternalStatusFromOrderExternalStatusDto";
import { toOrderLineFromOrderLineDto } from "./toOrderLineFromOrderLineDto";
import { toCustomerOrderFromOrderCustomerOrderDto } from "./toCustomerOrderFromOrderCustomerOrderDto";
import { toOrderStatus } from "./utils";

/** DTO → domain for one order, with its lines and every system's statuses at both levels. */
export const toOrderFromOrderDto = (dto: OrderDto): Order => {
  const externalReferences = (dto.externalReferences ?? []).map((x) =>
    toExternalReferenceFromOrderExternalReferenceDto(x),
  );
  const lines = (dto.lines ?? []).map((x) => toOrderLineFromOrderLineDto(x));
  const externalStatuses = (dto.externalStatuses ?? []).map((x) =>
    toExternalStatusFromOrderExternalStatusDto(x),
  );

  let customerOrder;
  if (dto.customerOrder) {
    customerOrder = toCustomerOrderFromOrderCustomerOrderDto(dto.customerOrder);
  }

  return {
    id: dto.id,
    orderNumber: dto.orderNumber,
    orderDate: dto.orderDate ?? undefined,
    source: dto.source ?? undefined,
    externalId: dto.externalId ?? undefined,
    externalReferences,
    lines,
    externalStatuses,
    customerOrder,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
    lastSyncedAt: dto.lastSyncedAt ?? undefined,
    status: toOrderStatus(dto.status),
  };
};
